export const ESPOTS = {
  HEADER_CART_CHECKOUT: 'HEADER_CART_CHECKOUT',
  HEADER_PROMOTION: 'HEADER_PROMOTION',
  HEADER_CP: 'HEADER_CP',
  HEADER_PHONE: 'HEADER_PHONE',
  FOOTER_LEGAL_NOTICE: 'FOOTER_LEGAL_NOTICE',
  HOMEPAGE_PUSH_1: 'HOMEPAGE_PUSH_1',
  HOMEPAGE_PUSH_2: 'HOMEPAGE_PUSH_2',
  HOMEPAGE_PUSH_3: 'HOMEPAGE_PUSH_3',
  HOMEPAGE_PUSH_4: 'HOMEPAGE_PUSH_4',
  HOMEPAGE_VIDEO: 'HOMEPAGE_VIDEO',
  FILTERS_NOPRODUCTS: 'FILTERS_NOPRODUCTS',
  EMPTY_CART: 'EMPTY_CART',
  CHECKOUT_HELP_SIDEBAR: 'CHECKOUT_HELP_SIDEBAR',
  PAGE_404_CONTENT: 'PAGE_404_CONTENT',
  PAGE_403_CONTENT: 'PAGE_403_CONTENT',
  CUSTOMIZATION_FOOTER_SIDEBAR: 'CUSTOMIZATION_FOOTER_SIDEBAR',
  CART_SECURE_INFO: 'CART_SECURE_INFO',
  NO_SEARCH_RESULT: 'NO_SEARCH_RESULT',
  STORAGE_COMPOSE_WINEBOX_MODAL: 'STORAGE_COMPOSE_WINEBOX_MODAL',
  ACCOUNT_EXPRO: 'ACCOUNT_EXPRO',
  YOUSIGN_INFORMATIONS: 'YOUSIGN_INFORMATIONS'
};

export const ESPOT_TYPE = {
  HTML: 'ESPOT_HTML',
  HTML_WITH_LINK: 'ESPOT_HTML_WITH_LINK',
  CARD: 'ESPOT_CARD',
  SAMPLE: 'ESPOT_SAMPLE',
  VIDEO: 'ESPOT_VIDEO',
  LIST: 'ESPOT_LIST',
  TEXT_ICON: 'ESPOT_TEXT_ICON',
  ACCORDION: 'ESPOT_ACCORDION',
  ESPOT_TRUSTED_SHOP: 'ESPOT_TRUSTED_SHOP',
  EMPTY_ITEM: 'EMPTY_ITEM'
};

export const ESPOT_LIST_TYPE = {
  CARD: 'CARD',
  SAMPLE: 'SAMPLE',
  DUO_CARD: 'DUO_CARD'
};

export const ESPOT_CARD_TYPE = {
  CARD_1: 'CARD_1',
  CARD_2: 'CARD_2',
  CARD_3: 'CARD_3',
  CARD_4: 'CARD_4'
};

export const ESPOT_LIST_DISPLAY = {
  LIST_1: 'LIST_1',
  LIST_2: 'LIST_2'
};

export const ACCORDION_ESPOT_IMG_SIZE = {
  WIDTH: '630',
  HEIGHT: '587'
};

export const ESPOT_LIST_ORIENTATION = {
  LEFT: 'LEFT',
  RIGHT: 'RIGHT'
};

export const PUSH_LISTING_ESPOT_IMAGES_FOLDER = {
  DESKTOP: '/h326/',
  MOBILE: '/h200/'
};

export const PUSH_LISTING_IMAGES_HEIGHT = {
  DESKTOP: {
    PRODUCT: 348,
    CATEG: 305
  },
  MOBILE: 200
};

export const TOP_BANNER_ESPOT_IMAGES_FOLDER = {
  DESKTOP: '/h150/'
};
